import { render, staticRenderFns } from "./HeaderNestedContent.vue?vue&type=template&id=6904bae6&"
import script from "./HeaderNestedContent.vue?vue&type=script&lang=js&"
export * from "./HeaderNestedContent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNestedContent.vue?vue&type=style&index=0&id=6904bae6&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports